import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import SearchableSelect from '../../common/SearchableSelect';
import { CreateDeviceState } from './useCreateDevice';

/** The configuration template to start from; its values are poured into the fields below. */
export const DeviceTemplateSection: React.FC<{ state: CreateDeviceState }> = ({ state }) => {
  const { t } = useI18n();
  const { form, templates, templatesLoading, selectedTemplateId } = state;

  const hint = !form.idClient
    ? t('devices.selectClientForTemplates')
    : templates.length === 0 && !templatesLoading
      ? t('devices.noTemplatesAvailable', { type: form.deviceType })
      : selectedTemplateId
        ? t('devices.templateValuesApplied')
        : null;

  return (
    <div className="device-section config-section">
      <h3 className="section-title">{t('devices.configurationTemplate')}</h3>
      <div className="config-normal">
        <div className="template-controls">
          <SearchableSelect
            value={selectedTemplateId != null ? String(selectedTemplateId) : ''}
            onChange={(next) => state.applyTemplate(next ? Number(next) : null)}
            disabled={templatesLoading || !form.idClient}
            className="template-select"
            placeholder={t('devices.noTemplate')}
            options={templates.map((template) => ({ value: String(template.id), label: template.name }))}
          />
        </div>
        {hint && <p className={`template-hint${selectedTemplateId ? ' template-applied' : ''}`}>{hint}</p>}
      </div>
    </div>
  );
};
